import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let percentage = useDataValue({
    context: 'payor',
    path: 'share.percentage',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    let values = Array.from({ length: 101 }, (_, i) => ({
      id: i,
      text: `${i}%`,
    }))
    if (percentage && values.every(item => item.id !== percentage)) {
      values.splice(Math.ceil(percentage), 0, {
        id: percentage,
        text: `${percentage}%`,
      })
    }

    return values
  }, [percentage])
}
